import React from 'react';

const Footer = () => (
  <footer className="footer">
    <h3 className="footer-h3">
      <span>Created By</span>
      <a className="footer-link" href="https://github.com/thecodechaser"> Ranjeet Singh</a>
    </h3>
  </footer>
);

export default Footer;
